import "./assets/css/customstyle.css";
import "./assets/sass/style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import Login from "./components/login/Login";
import ReceivingUnitLayout from "./layouts/ReceivingUnitLayout";
import PrivateRoutes from "./utils/PrivateRoutes";
import AdminLayout from "./layouts/AdminLayout";
import { SnackbarProvider } from "notistack";
import Loader from "./Loader.jsx";
const ProcurementDashboard = lazy(
  () => import("./components/procurementDashboard/ProcurementDashboard"),
);

const Dashboard = lazy(() => import("./components/dashboard/Dashboard"));
const Signup = lazy(() => import("./components/login/Signup"));
const AdminDashboard = lazy(
  () => import("./components/admin/admindashboard/AdminDashboard"),
);
const Users = lazy(
  () =>
    import("./components/admin/admindashboard/accessManagement/user/Users.tsx"),
);
const AddUser = lazy(
  () =>
    import("./components/admin/admindashboard/accessManagement/user/AddUser.tsx"),
);
const Roles = lazy(
  () =>
    import("./components/admin/admindashboard/accessManagement/role/Roles.tsx"),
);
const AddRole = lazy(
  () =>
    import("./components/admin/admindashboard/accessManagement/role/AddRole.tsx"),
);
const Levels = lazy(
  () => import("./components/admin/admindashboard/level/Levels"),
);
const EditUser = lazy(
  () =>
    import("./components/admin/admindashboard/accessManagement/user/EditUser.tsx"),
);
const EditRole = lazy(
  () =>
    import("./components/admin/admindashboard/accessManagement/role/EditRole.tsx"),
);
const TicketPage = lazy(() => import("./components/dashboard/TicketPage"));
const Searching = lazy(() => import("./components/dashboard/Searching"));
const NewSampleCollection = lazy(
  () => import("./components/samplecollection/NewSampleCollection"),
);
const EnvSampleCollection = lazy(
  () => import("./components/samplecollection/EnvSampleCollection"),
);
const Countries = lazy(
  () =>
    import("./components/admin/admindashboard/locations/country/Countries.tsx"),
);
const AddCountry = lazy(
  () =>
    import("./components/admin/admindashboard/locations/country/AddCountry.tsx"),
);
const EditCountry = lazy(
  () =>
    import("./components/admin/admindashboard/locations/country/EditCountry.tsx"),
);
const Provinces = lazy(
  () =>
    import("./components/admin/admindashboard/locations/province/Provinces.tsx"),
);
const Districts = lazy(
  () =>
    import("./components/admin/admindashboard/locations/district/Districts.tsx"),
);
const AddProvince = lazy(
  () =>
    import("./components/admin/admindashboard/locations/province/AddProvince.tsx"),
);
const SearchInput = lazy(() => import("./components/dashboard/SearchInput"));
const Menu = lazy(
  () =>
    import("./components/admin/admindashboard/accessManagement/menu/Menu.tsx"),
);
const Action = lazy(
  () =>
    import("./components/admin/admindashboard/accessManagement/action/Action.tsx"),
);
const Lookups = lazy(
  () => import("./components/admin/admindashboard/lookups/Lookups.tsx"),
);
const PageNotFount = lazy(() => import("./components/SideBar/PageNotFount"));
const Samples = lazy(() => import("./components/samplecollection/Samples"));
const SelectProvince = lazy(
  () => import("./components/dashboard/SelectProvince"),
);
const EnvironmentSamples = lazy(
  () => import("./components/samplecollection/EnvironmentSamples"),
);
const VirologySamples = lazy(
  () => import("./components/samplecollection/VirologySamples.jsx"),
);
const SerologySamples = lazy(
  () => import("./components/samplecollection/SerologySamples"),
);
const VirusIsolationWorksheet = lazy(
  () => import("./components/virusisolation/VirusIsolationWorksheet"),
);
const Counter = lazy(() => import("./components/virusisolation/Counter"));
const SewageSpecimenDatasheet = lazy(
  () => import("./components/admin/admindashboard/SewageSpecimenDatasheet"),
);
const EditAction = lazy(
  () =>
    import("./components/admin/admindashboard/accessManagement/action/EditAction.tsx"),
);
const AddAction = lazy(
  () =>
    import("./components/admin/admindashboard/accessManagement/action/AddAction.tsx"),
);
const AddLookups = lazy(
  () => import("./components/admin/admindashboard/lookups/AddLookups.tsx"),
);
const EditLookups = lazy(
  () => import("./components/admin/admindashboard/lookups/EditLookups.tsx"),
);
const EditProvinces = lazy(
  () =>
    import("./components/admin/admindashboard/locations/province/EditProvinces.tsx"),
);
const EditDistrict = lazy(
  () =>
    import("./components/admin/admindashboard/locations/district/EditDistrict.tsx"),
);
const AddDistrict = lazy(
  () =>
    import("./components/admin/admindashboard/locations/district/AddDistrict.tsx"),
);
const Help = lazy(() => import("./components/setting/Help"));
const Profile = lazy(() => import("./components/setting/Profile"));
const Setting = lazy(() => import("./components/setting/Setting"));
const EnvProcessing = lazy(
  () => import("./components/processing/EnvProcessing"),
);
const GenerateBarcode = lazy(
  () => import("./components/samplecollection/GenerateBarcode"),
);
const ViewStool = lazy(() => import("./components/samplecollection/ViewStool"));
const EnvInoculation = lazy(
  () => import("./components/inoculation/EnvInoculation"),
);
const StoolInoculation = lazy(
  () => import("./components/inoculation/StoolInoculation"),
);
const AfpObservation = lazy(
  () => import("./components/virusisolation/AfpObservation"),
);
const EnvObservation = lazy(
  () => import("./components/virusisolation/EnvObservation"),
);
const ViewEnv = lazy(() => import("./components/samplecollection/ViewEnv"));
const ViewEnvProcessing = lazy(
  () => import("./components/processing/ViewEnvProcessing"),
);
const ViewStoolProcessing = lazy(
  () => import("./components/processing/ViewStoolProcessing"),
);
const ViewStoolInoculation = lazy(
  () => import("./components/inoculation/ViewStoolInoculation"),
);
const ViewAFP = lazy(() => import("./components/virusisolation/ViewAFP"));
const AFPObservationWS = lazy(
  () => import("./components/virusisolation/AFPObservationWS"),
);
const EnvObservationWS = lazy(
  () => import("./components/virusisolation/EnvObservationWS"),
);
const ViewEnvInoculation = lazy(
  () => import("./components/inoculation/ViewEnvInoculation"),
);
const ViewEnvObservation = lazy(
  () => import("./components/virusisolation/ViewEnvObservation"),
);
const ItdSample = lazy(() => import("./components/pcr/ItdSample"));
const EditItd = lazy(() => import("./components/pcr/EditItd"));
const ItdPcr = lazy(() => import("./components/pcr/ItdPcr"));
const ReferedItd = lazy(() => import("./components/pcr/ReferedItd"));
const InitilizeVdvp = lazy(() => import("./components/pcr/InitilizeVdvp"));
const EditVdvp = lazy(() => import("./components/pcr/EditVdvp"));
const VdvpBatch = lazy(() => import("./components/pcr/VdvpBatch"));
const RefVdvp = lazy(() => import("./components/pcr/RefVdvp"));
const PcrRna = lazy(() => import("./components/pcr/PcrRna"));
const RnaList = lazy(() => import("./components/pcr/RnaList"));
const PendingRnaExtraction = lazy(
  () => import("./components/sequencing/rnaextraction/PendingRnaExtraction"),
);
const RTPCRResult = lazy(
  () => import("./components/sequencing/rnaextraction/RTPCRResult"),
);
const RequestFrom = lazy(
  () => import("./components/bioinformatics/RequestFrom"),
);
const ServiceReport = lazy(
  () => import("./components/bioinformatics/ServiceReport"),
);
const PrintReport = lazy(
  () => import("./components/bioinformatics/Print%20Report"),
);
const RepeatfromRTPCR = lazy(
  () => import("./components/sequencing/RepeatfromRTPCR"),
);
const DemandForm = lazy(
  () => import("./components/cellculture/demandForm/DemandForm"),
);
const CellForm = lazy(() => import("./components/cellculture/CellForm"));
const ReceiveInvetory = lazy(
  () => import("./components/inventory/ReceiveInvetory"),
);
const PCRPurification = lazy(
  () => import("./components/sequencing/PcrPurification"),
);
const RepeatfromSequencing = lazy(
  () => import("./components/sequencing/RepeatfromSequencing"),
);
const EditRnaBatch = lazy(
  () => import("./components/sequencing/rnaextraction/EditRnaBatch"),
);
const UpdatedRnaBatch = lazy(
  () => import("./components/sequencing/rnaextraction/UpdatedRnaBatch"),
);
const CycleSequencing = lazy(
  () => import("./components/sequencing/rnaextraction/CycleSequencing"),
);
const PendingCycleSequencing = lazy(
  () => import("./components/sequencing/rnaextraction/PendingCycleSequencing"),
);
const EditEnvSample = lazy(
  () => import("./components/samplecollection/EditEnvSample"),
);
const ColumnInRow = lazy(
  () => import("./components/virusisolation/ColumnInRow"),
);
const SewageDatasheet = lazy(
  () => import("./components/virusisolation/SewageDatasheet"),
);
const ItdTableSheet = lazy(() => import("./components/ItdTableSheet"));
const ModalTable = lazy(() => import("./components/virusisolation/ModalTable"));
const SpacimanList = lazy(() => import("./components/processing/SpacimanList"));
const AFPVirusIsolationSheet = lazy(
  () => import("./components/virusisolation/AFPVirusIsolationSheet"),
);
const ProcessingReagents = lazy(
  () => import("./components/virusisolation/ProcessingReagents"),
);
const InoculationReagents = lazy(
  () => import("./components/inoculation/InoculationReagents"),
);
const EditStool = lazy(
  () => import("./components/samplecollection/EditStoolSample"),
);
const AfpStoolProcessing = lazy(
  () => import("./components/processing/AfpStoolProcessing"),
);
const Categories = lazy(
  () =>
    import("./components/admin/admindashboard/inventry/Category/Categories.tsx"),
);
const AddCategory = lazy(
  () =>
    import("./components/admin/admindashboard/inventry/Category/AddCategory.tsx"),
);
const EditCategory = lazy(
  () =>
    import("./components/admin/admindashboard/inventry/Category/EditCategory.tsx"),
);
const Items = lazy(
  () => import("./components/admin/admindashboard/inventry/Items/items.tsx"),
);
const EditInventoryItem = lazy(
  () => import("./inventory/EditInventoryItem.jsx"),
);
const InventoryItems = lazy(() => import("./inventory/InventoryItems"));
const InventoryAddItem = lazy(() => import("./inventory/InventoryAddItem"));
const AddItems = lazy(
  () => import("./components/admin/admindashboard/inventry/Items/AddItems.js"),
);
const EditItem = lazy(
  () => import("./components/admin/admindashboard/inventry/Items/EditItem.jsx"),
);
const ItemManufacturer = lazy(
  () =>
    import("./components/admin/admindashboard/inventry/Manufacturer/ItemManufacturer.tsx"),
);
const ItemSupplier = lazy(
  () =>
    import("./components/admin/admindashboard/inventry/Supplier/ItemSupplier.tsx"),
);
const AddManufacturer = lazy(
  () =>
    import("./components/admin/admindashboard/inventry/Manufacturer/AddManufacturer.tsx"),
);
const EditManufacturer = lazy(
  () =>
    import("./components/admin/admindashboard/inventry/Manufacturer/EditManufacturer.tsx"),
);
const ItemModels = lazy(
  () =>
    import("./components/admin/admindashboard/inventry/Models/ItemModels.tsx"),
);
const AddModel = lazy(
  () =>
    import("./components/admin/admindashboard/inventry/Models/AddModel.tsx"),
);
const EditModel = lazy(
  () =>
    import("./components/admin/admindashboard/inventry/Models/EditModels.tsx"),
);
const Regions = lazy(
  () =>
    import("./components/admin/admindashboard/locations/region/Regions.tsx"),
);
const AddRegion = lazy(
  () =>
    import("./components/admin/admindashboard/locations/region/AddRegion.tsx"),
);
const EditRegion = lazy(
  () =>
    import("./components/admin/admindashboard/locations/region/EditRegion.tsx"),
);
const Tehsils = lazy(
  () =>
    import("./components/admin/admindashboard/locations/tehsil/Tehsils.tsx"),
);
const AddTehsil = lazy(
  () =>
    import("./components/admin/admindashboard/locations/tehsil/AddTehsil.tsx"),
);
const UnionCouncils = lazy(
  () =>
    import("./components/admin/admindashboard/locations/uc/UnionCouncils.tsx"),
);
const AddUnionCouncil = lazy(
  () =>
    import("./components/admin/admindashboard/locations/uc/AddUnionCouncil.tsx"),
);
const EditUnionCouncil = lazy(
  () =>
    import("./components/admin/admindashboard/locations/uc/EditUnionCouncil.tsx"),
);
const AllRecords = lazy(
  () => import("./components/virusisolation/AllRecords.jsx"),
);
const EditTehsil = lazy(
  () =>
    import("./components/admin/admindashboard/locations/tehsil/EditTehsil.tsx"),
);
const Sites = lazy(
  () =>
    import("./components/admin/admindashboard/locations/es-sites/Sites.tsx"),
);
const AddSite = lazy(
  () =>
    import("./components/admin/admindashboard/locations/es-sites/AddSite.tsx"),
);
const EnvModalTable = lazy(
  () => import("./components/samplecollection/EnvModalTable"),
);
const EnvSpacimanList = lazy(
  () => import("./components/samplecollection/EnvSpacimanList"),
);
const EnvVirusIsolationSheet = lazy(
  () => import("./components/samplecollection/EnvVirusIsolationSheet"),
);
const EnvProcessingReagents = lazy(
  () => import("./components/processing/envProcessing/EnvProcessingReagents"),
);
const EnvInoculationReagents = lazy(
  () => import("./components/processing/envProcessing/EnvInoculationReagents"),
);
const EditAddSite = lazy(
  () =>
    import("./components/admin/admindashboard/locations/es-sites/EditAddSite.tsx"),
);
const AnalyticalReport = lazy(
  () => import("./components/analyticalreport/AnalyticalReport"),
);
const Observation = lazy(
  () => import("./components/observation/Observation.jsx"),
);
const ESIsolates = lazy(
  () => import("./observationsec/esobservation/ESIsolates.js"),
);
const IsolatesList = lazy(
  () => import("./observationsec/esobservation/IsolatesList.js"),
);
const ReferredIsolates = lazy(
  () => import("./itdsection/referredisolates/ReferredIsolates.js"),
);
const StoolIsolates = lazy(
  () => import("./observationsec/stoolobservation/StoolIsolates.js"),
);
const StoolIsolatesList = lazy(
  () => import("./observationsec/stoolobservation/StoolIsolatesList.js"),
);
const EsSitesComplianceReport = lazy(
  () =>
    import("./esreports/essitescompliancereports/EsSitesComplianceReport.js"),
);
const EsSitesSamplingSchedule = lazy(
  () =>
    import("./esreports/essitescompliancereports/EsSitesSamplingSchedule.js"),
);
const ProvinceWiseSitesMonthlySummary = lazy(
  () =>
    import("./esreports/essitescompliancereports/ProvinceWiseSitesMonthlySummary.js"),
);
const EsSitesWeeklySummary = lazy(
  () => import("./esreports/essitescompliancereports/EsSitesWeeklySummary.js"),
);
const EsComplianceNewReport = lazy(
  () => import("./esreports/essitescompliancereports/EsComplianceNewReport.js"),
);
const ItdInitialized = lazy(
  () => import("./itdsection/itdinitialized/ItdInitialized.js"),
);
const ItdInitializedBatches = lazy(
  () => import("./itdsection/itdinitialized/ItdInitializedBatches.js"),
);
const ItdViewResult = lazy(
  () => import("./itdsection/itdinitialized/ItdViewResult"),
);
const VDPVReferred = lazy(
  () => import("./vdpvsection/referredfromitd/VDPVReferred"),
);
const SeqReferred = lazy(
  () => import("./sequencingsection/referredfromitd/SeqReferred"),
);
const VdpvInitializedBatches = lazy(
  () => import("./vdpvsection/vdpvinitialized/VdpvInitializedBatches.js"),
);
const VdpvInitialized = lazy(
  () => import("./vdpvsection/vdpvinitialized/VdpvInitialized"),
);
const VdpvViewResult = lazy(
  () => import("./vdpvsection/vdpvinitialized/VdpvViewResult"),
);
const SeqInitializedBatches = lazy(
  () =>
    import("./sequencingsection/initializedseqbatches/SeqInitializedBatches"),
);
const InitializedRtPcrBatches = lazy(
  () => import("./rtpcrsection/initializedrtpcr/InitializedRtPcrBatches.js"),
);
const RtPcrInitialized = lazy(
  () => import("./rtpcrsection/initializedrtpcr/RtPcrInitialized.js"),
);
const ReferredRtPcr = lazy(
  () => import("./rtpcrsection/referredrtpcr/ReferredRtPcr"),
);
const Equipment = lazy(() => import("./inventory/Equipment"));
const PurificationBatches = lazy(
  () => import("./rtpcrsection/purification/PurificationBatches"),
);
const CycleSequencingBatches = lazy(
  () =>
    import("./cyclesequencingsec/batchescyclesequencing/CycleSequencingBatches"),
);
const InitializedCycleSequecing = lazy(
  () =>
    import("./cyclesequencingsec/initializedcyclesequencing/InitializedCycleSequecing"),
);
const ViewCycleSequencingBatches = lazy(
  () =>
    import("./cyclesequencingsec/batchescyclesequencing/ViewCycleSequencingBatches.jsx"),
);
const AddEquipment = lazy(() => import("./inventory/AddEquipment"));
const AddItem = lazy(() => import("./inventory/InventoryAddItem"));
const EquipmentEdit = lazy(() => import("./inventory/EquipmentEdit"));
const SequencingReport = lazy(
  () => import("./cyclesequencingsec/sequencingReport/SequencingReport"),
);
const AddReceiveInfo = lazy(
  () => import("./components/inventory/AddReceiveInfo.js"),
);
const ViewInventoryDetail = lazy(
  () => import("./components/inventory/ViewInventoryDetail"),
);
const InventoryIssuance = lazy(
  () => import("./components/inventory/inventoryissuance/InventoryIssuance"),
);
const Requisition = lazy(
  () => import("./components/inventory/requisition/Requisition"),
);
const NewRequisition = lazy(
  () => import("./components/inventory/requisition/NewRequisition"),
);
const Issuance = lazy(
  () => import("./components/inventory/inventoryissuance/Issuance"),
);
const ViewIssuanceDetail = lazy(
  () => import("./components/inventory/inventoryissuance/ViewIssuanceDetail"),
);
const StockList = lazy(
  () => import("./components/inventory/stockreceive/StockList"),
);
const ViewStockReceivedDetail = lazy(
  () => import("./components/inventory/stockreceive/ViewStockReceivedDetail"),
);
const NewDemandForm = lazy(
  () => import("./components/cellculture/demandForm/NewDemandForm.jsx"),
);
const AddSupplier = lazy(
  () =>
    import("./components/admin/admindashboard/inventry/Supplier/AddSupplier.tsx"),
);
const EditSupplier = lazy(
  () =>
    import("./components/admin/admindashboard/inventry/Supplier/EditSupplier.tsx"),
);
const NewReceiveCellLine = lazy(
  () =>
    import("./components/cellculture/receiveCellLine/NewReceiveCellLine.jsx"),
);
const NewCellSensitivityForm = lazy(
  () =>
    import("./components/cellculture/cellLineSensitivity/NewCellSensitivityForm.jsx"),
);
const CellSensitivityForm = lazy(
  () =>
    import("./components/cellculture/cellLineSensitivity/CellSensitivityForm.js"),
);
const EditDemandForm = lazy(
  () => import("./components/cellculture/demandForm/EditDemandForm"),
);

const CellLineRevivalForm = lazy(
  () =>
    import("./components/cellculture/cellLineRevival/CellLineRevivalForm.js"),
);

const IssueCellCulture = lazy(
  () =>
    import("./components/cellculture/demandForm/IssueCellCulture/IssueCellCulture"),
);
const EditCellSensitivityForm = lazy(
  () =>
    import("./components/cellculture/cellLineSensitivity/EditCellSensitivityForm.jsx"),
);
const StockReceived = lazy(
  () => import("./components/cellculture/stockreceive/StockReceived"),
);
const ViewCCStockDetail = lazy(
  () => import("./components/cellculture/stockreceive/ViewCCStockDetail"),
);
const ReceiveCelCulture = lazy(
  () =>
    import("./components/cellculture/demandForm/IssueCellCulture/ReceiveCellCulture.jsx"),
);
const ViewCellSensitivityForm = lazy(
  () =>
    import("./components/cellculture/cellLineSensitivity/ViewCellSensitivityForm.jsx"),
);
const ReceiveMedia = lazy(
  () => import("./components/cellculture/receiveMedia/ReceiveMedia"),
);
const NewReceiveMedia = lazy(
  () => import("./components/cellculture/receiveMedia/NewReceiveMedia"),
);
const MediaDemandForms = lazy(
  () => import("./components/cellculture/mediaForm/MediaDemandForms.js"),
);
const NewMediaDemandFroms = lazy(
  () => import("./components/cellculture/mediaForm/NewMediaDemandFroms"),
);
const IssueMedia = lazy(
  () => import("./components/cellculture/mediaForm/mediaIssue/IssueMedia"),
);
const NewIssueMediaForm = lazy(
  () =>
    import("./components/cellculture/mediaForm/mediaIssue/NewIssueMediaForm"),
);
const MediaStockReceived = lazy(
  () =>
    import("./components/cellculture/mediaForm/stockform/MediaStockReceived"),
);
const EditMediaForm = lazy(
  () => import("./components/cellculture/mediaForm/EditMediaForm"),
);
const ViewIReceiveCellLineDetail = lazy(
  () =>
    import("./components/cellculture/receiveCellLine/ViewIReceiveCellLineDetail"),
);
const ViewIReceiveMediaDetail = lazy(
  () => import("./components/cellculture/receiveMedia/ViewIReceiveMediaDetail"),
);
const ViewIReceiveMediaStock = lazy(
  () =>
    import("./components/cellculture/mediaForm/stockform/ViewIReceiveMediaStock"),
);
const ViewissueCellCulture = lazy(
  () =>
    import("./components/cellculture/demandForm/IssueCellCulture/ViewissueCellCulture"),
);
const ViewissueMedia = lazy(
  () => import("./components/cellculture/mediaForm/mediaIssue/ViewissueMedia"),
);
const CellLineReceiveListing = lazy(
  () =>
    import("./components/cellculture/cellLineReceive/CellLineReceiveListing.js"),
);

const CurrentBalance = lazy(
  () => import("./components/inventory/currentbalance/CurrentBalance"),
);

const CellLineMasterBandkListing = lazy(
  () =>
    import("./components/cellculture/cellLinesMasterBank/CellLineMasterBandkListing"),
);

const CellLinesWorkingCellBankListing = lazy(
  () =>
    import("./components/cellculture/cellLinesWorkingCellBank/CellLinesWorkingCellBankListing"),
);

const CellLinesStorageListing = lazy(
  () =>
    import("./components/cellculture/cellLinesStorage/CellLinesStorageListing"),
);

const EditReceiveMedia = lazy(
  () => import("./components/cellculture/receiveMedia/EditReceiveMedia"),
);
const DataRepository = lazy(
  () => import("./components/dataRepository/DataRepository"),
);
const CelllineSubculturingListing = lazy(
  () =>
    import("./components/cellculture/celllineSubculturing/CelllineSubculturingListing"),
);
const NewCelllineSubculturing = lazy(
  () =>
    import("./components/cellculture/celllineSubculturing/NewCelllineSubculturing"),
);
const EditCelllineSubculturing = lazy(
  () =>
    import("./components/cellculture/celllineSubculturing/EditCelllineSubculturing"),
);
const EnvProcessingReagentReport = lazy(
  () =>
    import("./components/processing/envProcessing/EnvProcessingReagentReport"),
);
const CellSensitivityTrendSheet = lazy(
  () =>
    import("./components/cellculture/cellLineSensitivity/CellSensitivityTrendSheet"),
);
const CellDocumentationRoot = lazy(
  () =>
    import("./components/cellculture/cellDocumentation/CellDocumentationRoot"),
);
const ItdtoSequencingReferredSheet = lazy(
  () =>
    import("./itdsection/reports-and-sheets/ItdtoSequencingReferredSheet.jsx"),
);
const ITDReport = lazy(
  () => import("./itdsection/reports-and-sheets/ITDReport"),
);
const PendingDtrPurification = lazy(
  () =>
    import("./components/sequencing/rnaextraction/PendingDtrPurification.js"),
);
const DtrPurificationBatches = lazy(
  () => import("./components/sequencing/rnaextraction/DtrPurificationBatches"),
);
const MainInspiredIntegratedDashboard = lazy(
  () =>
    import("./inspired-integrated-dashboard/pages/MainInspiredIntegratedDashboard.jsx"),
);
const DailyRecordsReport = lazy(
  () => import("./observationsec/stoolobservation/DailyRecordsReport"),
);
const AfpProcessingReagentReport = lazy(
  () => import("./components/virusisolation/AfpProcessingReagentReport"),
);
const ESDailyRecordsReport = lazy(
  () => import("./observationsec/stoolobservation/ESDailyRecordsReport"),
);
const ManageAfpObservation = lazy(
  () => import("./components/virusisolation/ManageAfpObservation"),
);
const ManageEnvObservation = lazy(
  () => import("./components/virusisolation/ManageEnvObservation"),
);
const SampleDataView = lazy(
  () => import("./components/virusisolation/SampleDataView"),
);
const AFPManageSampleStorage = lazy(
  () => import("./components/manageStorage/afpStorage/AfpManageSampleStorage"),
);
const ESManageSampleStorage = lazy(
  () => import("./components/manageStorage/esStorage/EsManageSampleStorage"),
);
const ITDManageSampleStorage = lazy(
  () => import("./components/manageStorage/itdStorage/ITDManageSampleStorage"),
);
const DiscardAfpSamples = lazy(
  () => import("./components/manageStorage/afpStorage/DiscardAfpSamples"),
);
const DiscardEsSamples = lazy(
  () => import("./components/manageStorage/esStorage/DiscardEsSamples"),
);
const DiscardItdSamples = lazy(
  () => import("./components/manageStorage/itdStorage/DiscardItdSamples"),
);
const MoveAfpSamples = lazy(
  () => import("./components/manageStorage/afpStorage/moveSamples"),
);
const MoveEsSamples = lazy(
  () => import("./components/manageStorage/esStorage/moveSamples"),
);
const MoveItdSamples = lazy(
  () => import("./components/manageStorage/itdStorage/moveSamples"),
);
const AFPErrorReport = lazy(
  () => import("./components/virusisolation/AFPErrorReport"),
);
const AFPErrorReportList = lazy(
  () => import("./components/virusisolation/AFPErrorReportList"),
);
const EsErrorReportList = lazy(
  () => import("./components/virusisolation/EsErrorReportList"),
);
const EsErrorReport = lazy(
  () => import("./components/virusisolation/EsErrorReport"),
);
const ManageStorageCapacity = lazy(
  () => import("./components/manageCapacity/ManageStorageCapacity"),
);
const IsolateInventoryList = lazy(
  () => import("./observationsec/stoolobservation/IsolateInventoryList"),
);
const EsIsolateInventoryList = lazy(
  () => import("./observationsec/esobservation/EsIsolateInventoryList"),
);
const EnvDailyWorkLoadReport = lazy(
  () => import("./esreports/esdailyworkloadreport/EnvDailyWorkLoadReport"),
);
const InventoryList = lazy(
  () => import("./components/StoolandSupernatantInventory/InventoryList"),
);
const ControlsObservationManagement = lazy(
  () => import("./components/virusisolation/controlsObservationManagement"),
);
const EScontrolsObservationManagement = lazy(
  () => import("./components/virusisolation/EScontrolsObservationManagement"),
);
const SequencingResults = lazy(
  () => import("./components/sequencing/SequencingResults"),
);
const PcrVerification = lazy(
  () => import("./itdsection/pcrverification/PcrVerification"),
);
const SequencingResultBatches = lazy(
  () => import("./components/sequencing/SequencingResultBatches"),
);
const ViewItdFinalResult = lazy(
  () => import("./itdsection/itdinitialized/ViewItdFinalResult"),
);
const Procurement = lazy(
  () => import("./components/inventory/procurement/Procurement"),
);
const RequestProcurement = lazy(
  () => import("./components/inventory/procurement/RequestProcurement"),
);
const ViewProcurementDetail = lazy(
  () => import("./components/inventory/procurement/ViewProcurementDetail"),
);
const POManagementSystem = lazy(
  () => import("./components/inventory/procurement/POManagementSystem"),
);
const EditProcurementDetail = lazy(
  () => import("./components/inventory/procurement/EditProcurementDetail"),
);
const ViewPODetail = lazy(
  () => import("./components/poManagementSystem/ViewPODetail"),
);
const WorkloadAndResultDashboard = lazy(
  () =>
    import("./components/workloadAndResultDashboard/WorkloadAndResultDashboard"),
);
const FinalBatches = lazy(() => import("./components/sequencing/FinalBatches"));
const ItdVdpvResultsConfig = lazy(
  () => import("./itdsection/ItdVdpvResultsConfig"),
);
const EnvCheckListReport = lazy(
  () => import("./components/processing/EnvCheckListReport"),
);
const EnvProcessingGrabChecklist = lazy(
  () => import("./components/processing/EnvProcessingGrabChecklist"),
);
const ITDdailyWeeklyMonthlyReport = lazy(
  () => import("./itdsection/reports-and-sheets/ITDdailyWeeklyMonthlyReport"),
);
const ITDReportDashboard = lazy(
  () => import("./components/itdReportDashboard/ITDReportDashboard"),
);
const NpevAndSlRateReport = lazy(
  () => import("./components/virusisolation/NpevAndSlRateReport"),
);
const TatComplianceReport = lazy(
  () => import("./components/virusisolation/TatComplianceReport"),
);
const SequencingReportDashboard = lazy(
  () =>
    import("./components/sequencingReportDashboard/SequencingReportDashboard"),
);
const WeeklyQCReport = lazy(
  () => import("./components/virusisolation/WeeklyQCReport"),
);
const WpvMonitoringReport = lazy(
  () => import("./components/virusisolation/WpvMonitoringReport"),
);
const WorkloadAndThroughputReport = lazy(
  () => import("./components/virusisolation/WorkloadAndThroughputReport"),
);
const DiagnosticAccuracyReport = lazy(
  () => import("./components/virusisolation/DiagnosticAccuracyReport"),
);
const SeqResultsVerification = lazy(
  () => import("./components/sequencing/SeqResultsVerification"),
);
const AfpProcessingInoculationDashboard = lazy(
  () =>
    import("./inspired-integrated-dashboard/pages/AfpProcessingInoculationDashboard"),
);
const DiscardedSamples = lazy(
  () => import("./components/manageStorage/afpStorage/DiscardedSamples"),
);
const ManageStorage = lazy(
  () => import("./components/manageStorage/afpStorage/ManageStorage"),
);
const EsManageStorage = lazy(
  () => import("./components/manageStorage/esStorage/ManageStorage"),
);
const ItdManageStorage = lazy(
  () => import("./components/manageStorage/itdStorage/ItdManageStorage"),
);
const EsDiscardedSamples = lazy(
  () => import("./components/manageStorage/esStorage/DiscardedSamples"),
);
const ItdDiscardedSamples = lazy(
  () => import("./components/manageStorage/itdStorage/ItdDiscardedSamples"),
);
const SequencingPendingResult = lazy(
  () => import("./components/sequencing/SequencingPendingResult"),
);
const ItdPendingResult = lazy(
  () => import("./components/pcr/ItdPendingResult"),
);
const L20BPositiveResult = lazy(
  () => import("./components/pcr/L20BPositiveResult"),
);
const CulturePendingResults = lazy(
  () => import("./components/cellculture/CulturePendingResults"),
);
const AfpDocumentation = lazy(
  () => import("./components/virusisolation/AfpDocumentation"),
);
const LabWeeklyProgressReport = lazy(
  () => import("./components/pcr/LabWeeklyProgressReport"),
);
const ReInoculationHistory = lazy(
  () => import("./components/virusisolation/ReInoculationHistory"),
);

// import MainDashboard from "./components/dashboard/MainDashboard";
// import ReceiveCellLine from "./components/cellculture/receiveCellLine/ReceiveCellLine.jsx";
// import ViewCelllineSubculturing from "./components/cellculture/celllineSubculturing/ViewCelllineSubculturing";
// import Report from "./Report";

function App() {
  return (
    <SnackbarProvider
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      <div className="app main-wrapper primary-color" id="main-body">
        <Suspense fallback={<div>{<Loader variant="bars" />}</div>}>
          <Routes>
            <Route element={<PrivateRoutes />}>
              <Route element={<AdminLayout />}>
                <Route path="/admin/dashboard" element={<AdminDashboard />} />
                <Route path="/admin/users" element={<Users />} />
                <Route path="/admin/addNewUser" element={<AddUser />} />
                <Route path="/admin/edituser/:id" element={<EditUser />} />
                <Route path="/admin/editaction/:id" element={<EditAction />} />
                <Route
                  path="/admin/editlookups/:id"
                  element={<EditLookups />}
                />
                <Route path="/admin/categories" element={<Categories />} />
                <Route path="/admin/addCategory" element={<AddCategory />} />
                <Route
                  path="/admin/editCategory/:id"
                  element={<EditCategory />}
                />
                <Route path="/admin/items" element={<Items />} />
                <Route path="/admin/addItems" element={<AddItems />} />

                <Route path="/admin/editItem/:id" element={<EditItem />} />

                <Route
                  path="/admin/itemManufacturer"
                  element={<ItemManufacturer />}
                />
                <Route path="/admin/suppliers" element={<ItemSupplier />} />
                <Route
                  path="/admin/addItemManufacturer"
                  element={<AddManufacturer />}
                />
                <Route path="/admin/addSupplier" element={<AddSupplier />} />

                <Route
                  path="/admin/editManufacturer/:id"
                  element={<EditManufacturer />}
                />
                <Route
                  path="/admin/editSupplier/:id"
                  element={<EditSupplier />}
                />

                <Route path="/admin/itemModels" element={<ItemModels />} />
                <Route path="/admin/addModel" element={<AddModel />} />
                <Route path="/admin/editModel/:id" element={<EditModel />} />

                <Route path="/admin/region" element={<Regions />} />
                <Route path="/admin/AddRegion" element={<AddRegion />} />
                <Route path="/admin/editRegion/:id" element={<EditRegion />} />

                <Route path="/admin/tehsil" element={<Tehsils />} />
                <Route path="/admin/addTehsil" element={<AddTehsil />} />
                <Route path="/admin/editTehsil/:id" element={<EditTehsil />} />

                <Route
                  path="/admin/editprovinces/:id"
                  element={<EditProvinces />}
                />
                <Route
                  path="/admin/editdistrict/:id"
                  element={<EditDistrict />}
                />

                <Route path="/admin/uc" element={<UnionCouncils />} />
                <Route
                  path="/admin/addUnionCouncil"
                  element={<AddUnionCouncil />}
                />

                <Route
                  path="/admin/editUnionCouncil/:id"
                  element={<EditUnionCouncil />}
                />

                <Route path="/admin/essites" element={<Sites />} />
                <Route path="/admin/addSites" element={<AddSite />} />
                <Route path="/admin/editSites/:id" element={<EditAddSite />} />

                <Route path="/admin/addlookups" element={<AddLookups />} />
                <Route path="/admin/adddistrict" element={<AddDistrict />} />
                <Route path="/admin/addAction" element={<AddAction />} />
                <Route path="/admin/roles" element={<Roles />} />
                <Route path="/admin/addNewRole" element={<AddRole />} />
                <Route path="/admin/editrole/:id" element={<EditRole />} />
                <Route path="/admin/country" element={<Countries />} />
                <Route path="/admin/addCountry" element={<AddCountry />} />
                <Route
                  path="/admin/editCountry/:id"
                  element={<EditCountry />}
                />
                <Route path="/admin/province" element={<Provinces />} />
                <Route path="/admin/LookUpListingPage" element={<Lookups />} />
                <Route path="/admin/addProvince" element={<AddProvince />} />
                <Route path="/admin/district" element={<Districts />} />
                <Route path="/admin/levels" element={<Levels />} />
                <Route path="/admin/menu" element={<Menu />} />
                <Route path="/admin/actions" element={<Action />} />
                <Route path="/admin/SettingPage" element={<Setting />} />
                <Route path="*" element={<PageNotFount />} />
              </Route>

              <Route element={<ReceivingUnitLayout />}>
                {/* <Route path="/dashboard" element={<MainDashboard />} /> */}
                <Route
                  path="/dashboard"
                  element={<MainInspiredIntegratedDashboard />}
                />
                <Route
                  path="/recevingDashboard"
                  element={<MainInspiredIntegratedDashboard />}
                />
                <Route
                  path="/afpProcInocDashboard"
                  element={<AfpProcessingInoculationDashboard />}
                />
                <Route
                  path="/afpProcessingDashboard"
                  element={<MainInspiredIntegratedDashboard />}
                />
                <Route
                  path="/afpInaculationDashboard"
                  element={<MainInspiredIntegratedDashboard />}
                />
                <Route
                  path="/afpObservationDashboard"
                  element={<MainInspiredIntegratedDashboard />}
                />
                <Route path="/maindashboard" element={<Dashboard />} />
                <Route path="/tickets" element={<TicketPage />} />
                <Route path="/search" element={<SearchInput />} />
                <Route path="/search1" element={<SelectProvince />} />
                <Route
                  path="/environmentObservation"
                  element={<EnvObservationWS />}
                />
                <Route
                  path="/environmentObservationSheet/:id"
                  element={<SewageSpecimenDatasheet />}
                />
                <Route path="/tickets" element={<TicketPage />} />
                <Route path="/searching" element={<Searching />} />
                <Route path="/search" element={<SearchInput />} />
                <Route path="/search1" element={<SelectProvince />} />
                <Route
                  path="/newSampleCollection"
                  element={<NewSampleCollection />}
                />
                <Route path="/cases" element={<Samples />} />
                <Route path="/environment" element={<EnvironmentSamples />} />
                <Route
                  path="/envsamplecollection"
                  element={<EnvSampleCollection />}
                />
                <Route
                  path="/envsamplecollection/:id"
                  element={<EnvSampleCollection />}
                />
                <Route path="/observations" element={<Observation />} />
                <Route
                  path="/PendingRNAExtraction"
                  element={<PendingRnaExtraction />}
                />
                <Route path="/stool" element={<VirologySamples />} />
                <Route path="/allrecords" element={<AllRecords />} />
                <Route
                  path="/viewDataSheet/:id"
                  element={<AFPVirusIsolationSheet />}
                />
                <Route
                  path="/EnvviewDataSheet/:id"
                  element={<EnvVirusIsolationSheet />}
                />
                <Route path="/editstool/:id" element={<EditStool />} />
                <Route path="/viewstool/:id" element={<ViewStool />} />
                <Route
                  path="/viewenvInoculation/:id"
                  element={<ViewEnvInoculation />}
                />
                g{" "}
                <Route
                  path="/viewenvprocessing/:id"
                  element={<ViewEnvProcessing />}
                />
                <Route
                  path="/viewstoolprocessing/:id"
                  element={<ViewStoolProcessing />}
                />
                <Route
                  path="/envProcessingReagents"
                  element={<EnvProcessingReagents />}
                />
                <Route
                  path="/envProcessingReagentsReport/"
                  element={<EnvProcessingReagentReport />}
                />
                <Route
                  path="/envDailyWorkLoadReport/"
                  element={<EnvDailyWorkLoadReport />}
                />
                <Route
                  path="/processingReagentsReport/"
                  element={<AfpProcessingReagentReport />}
                />
                <Route
                  path="/envinoculationreagents/"
                  element={<EnvInoculationReagents />}
                />
                <Route path="/serum" element={<SerologySamples />} />
                <Route path="/afpObservation" element={<AFPObservationWS />} />
                <Route
                  path="/afpObservationSheet/:id"
                  element={<VirusIsolationWorksheet />}
                />
                <Route path="/envProcessing" element={<EnvProcessing />} />
                <Route
                  path="/envChecklistsReport"
                  element={<EnvCheckListReport />}
                />
                <Route path="/generatebarcode" element={<GenerateBarcode />} />
                <Route path="/counter" element={<Counter />} />
                <Route path="/tutorial" element={<Help />} />
                <Route path="/profile" element={<Profile />} />
                <Route
                  path="/stoolInoculation"
                  element={<StoolInoculation />}
                />
                <Route
                  path="/InoculationReagents"
                  element={<InoculationReagents />}
                />
                <Route
                  path="/stoolProcessing"
                  element={<AfpStoolProcessing />}
                />
                <Route path="/itdsample" element={<ItdSample />} />
                <Route path="/edititd" element={<EditItd />} />
                <Route path="/itdpcr" element={<ItdPcr />} />
                <Route path="/refereditd" element={<ReferedItd />} />
                <Route path="/initilizeVdvp" element={<InitilizeVdvp />} />
                <Route path="/EditVdvp" element={<EditVdvp />} />
                <Route path="/VdvpBatch" element={<VdvpBatch />} />
                <Route path="/Refvdvp" element={<RefVdvp />} />
                <Route path="/PcrRna" element={<PcrRna />} />
                <Route path="/RnaList" element={<RnaList />} />
                <Route path="/counter" element={<Counter />} />
                <Route path="/tutorial" element={<Help />} />
                <Route path="/profile" element={<Profile />} />
                <Route
                  path="/envProcessingGrabChecklist"
                  element={<EnvProcessingGrabChecklist />}
                />
                {/* <Route path='/InitializeITDsample' element={<ItdSample />} /> */}
                {/* ==============ITD======================= */}
                <Route
                  path="/InitializedBatches"
                  element={<ItdInitializedBatches />}
                />
                <Route
                  path="/viewItdFinalResult/:id"
                  element={<ViewItdFinalResult />}
                />
                {/* ITD Initialized */}
                <Route path="/itdInitialized" element={<ItdInitialized />} />
                <Route path="/viewItdResult/:id" element={<ItdViewResult />} />
                {/* ========ITD END============================= */}
                {/* ===================VDPV===================== */}
                <Route path="/RefredfromITD" element={<VDPVReferred />} />
                <Route
                  path="/initializeVDPVBatches"
                  element={<VdpvInitializedBatches />}
                />
                <Route path="/vdpvInitialized" element={<VdpvInitialized />} />
                <Route
                  path="/viewVdpvResult/:id"
                  element={<VdpvViewResult />}
                />
                {/* ====vdpv end ==================================*/}
                {/* RTPCR  */}
                <Route
                  path="/rTPcrBatches"
                  element={<InitializedRtPcrBatches />}
                />
                <Route
                  path="/initializedRtPcrBatch"
                  element={<RtPcrInitialized />}
                />
                <Route
                  path="/purificationBatches"
                  element={<PurificationBatches />}
                />
                <Route path="/EditITDBatch" element={<EditItd />} />
                <Route path="/ITDPCRBatch" element={<ItdPcr />} />
                <Route
                  path="/InitializeVDPVsample"
                  element={<InitilizeVdvp />}
                />
                <Route path="/EditVDPVBatch" element={<EditVdvp />} />
                <Route path="/VDPVPCRBatch" element={<VdvpBatch />} />
                <Route path="/RefredfromVDPV" element={<RefVdvp />} />
                <Route path="/PCRRNA" element={<PcrRna />} />
                <Route path="/RNAExtractedList" element={<RnaList />} />
                <Route path="/RequestForm" element={<RequestFrom />} />
                <Route path="/ServiceReport" element={<ServiceReport />} />
                <Route path="/PrintReport" element={<PrintReport />} />
                <Route path="/counter" element={<Counter />} />
                <Route path="/tutorial" element={<Help />} />
                <Route path="/profile" element={<Profile />} />
                {/* <Route path='/afpObservation' element={<AfpObservation />} /> */}
                <Route
                  path="/afpDataManagement"
                  element={<ManageAfpObservation />}
                />
                {/* Read-only combined (stool + env) sample data search */}
                <Route path="/sampleDataView" element={<SampleDataView />} />
                {/* <Route path="/stoolProcessing" element={<StoolProcessing />} /> */}
                <Route path="/itdsample" element={<ItdSample />} />
                <Route path="/edititd" element={<EditItd />} />
                <Route path="/itdpcr" element={<ItdPcr />} />
                <Route path="/refereditd" element={<ReferedItd />} />
                <Route path="/initilizeVdvp" element={<InitilizeVdvp />} />
                <Route path="/EditVdvp" element={<EditVdvp />} />
                <Route path="/VdvpBatch" element={<VdvpBatch />} />
                <Route path="/Refvdvp" element={<RefVdvp />} />
                <Route path="/PcrRna" element={<PcrRna />} />
                <Route path="/RnaList" element={<RnaList />} />
                <Route path="/counter" element={<Counter />} />
                <Route path="/tutorial" element={<Help />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/envInoculation" element={<EnvInoculation />} />
                <Route path="/InitializeITDsample" element={<ItdSample />} />
                <Route path="/EditITDBatch" element={<EditItd />} />
                <Route path="/ITDPCRBatch" element={<ItdPcr />} />
                {/* <Route path="/RefredfromITD" element={<ReferedItd />} /> */}
                <Route
                  path="/InitializeVDPVsample"
                  element={<InitilizeVdvp />}
                />
                <Route path="/EditVDPVBatch" element={<EditVdvp />} />
                <Route path="/VDPVPCRBatch" element={<VdvpBatch />} />
                <Route path="/RefredfromVDPV" element={<RefVdvp />} />
                <Route path="/PCRRNA" element={<PcrRna />} />
                <Route path="/RNAExtractedList" element={<RnaList />} />
                <Route path="/RequestForm" element={<RequestFrom />} />
                <Route path="/ServiceReport" element={<ServiceReport />} />
                <Route path="/PrintReport" element={<PrintReport />} />
                <Route path="/RepeatfromRTPCR" element={<RepeatfromRTPCR />} />
                {/* Cell culture */}
                <Route path="/DemandForm" element={<DemandForm />} />
                <Route path="/mediaDemandForm" element={<MediaDemandForms />} />
                <Route
                  path="/NewMediaDemandFroms"
                  element={<NewMediaDemandFroms />}
                />
                <Route
                  path="/NewissueCelCulture"
                  element={<IssueCellCulture />}
                />
                <Route
                  path="/NewIssueMediaForm"
                  element={<NewIssueMediaForm />}
                />
                <Route
                  path="/issueCellCulture"
                  element={<ReceiveCelCulture />}
                />
                <Route
                  path="/ViewissueCellCulture/:id"
                  element={<ViewissueCellCulture />}
                />
                <Route path="/IssueMedia" element={<IssueMedia />} />
                <Route
                  path="/ViewIssueMedia/:id"
                  element={<ViewissueMedia />}
                />
                <Route
                  path="/editDemandForm/:id"
                  element={<EditDemandForm />}
                />
                <Route path="/editMediaForm/:id" element={<EditMediaForm />} />
                <Route path="/newDemandForm" element={<NewDemandForm />} />
                <Route
                  path="/NewReceiveCellLine"
                  element={<NewReceiveCellLine />}
                />
                {/*  ReceiveCellCulture */}
                <Route
                  path="/receivedCellLines"
                  element={<CellLineReceiveListing />}
                />
                <Route
                  path="/viewReceiveCellCultureDetail/:id"
                  element={<ViewIReceiveCellLineDetail />}
                />
                <Route
                  path="/cellCultureMediaPrepartion"
                  element={<ReceiveMedia />}
                />
                <Route
                  path="/ViewReceiveMedia/:id"
                  element={<ViewIReceiveMediaDetail />}
                />
                <Route
                  path="/EditReceiveMedia/:id"
                  element={<EditReceiveMedia />}
                />
                <Route path="/NewReceiveMedia" element={<NewReceiveMedia />} />
                <Route
                  path="/CellCultureTransferredForm"
                  element={<CellForm />}
                />
                <Route
                  path="/CellSensitivityForm"
                  element={<CellSensitivityForm />}
                />
                <Route
                  path="/NewCellSensitivityForm"
                  element={<NewCellSensitivityForm />}
                />
                <Route
                  path="/cellSensitivityTrendSheet"
                  element={<CellSensitivityTrendSheet />}
                />
                <Route
                  path="/cellLineRevival"
                  element={<CellLineRevivalForm />}
                />
                {/* Cell Culture stock rceiving in sections after issuance by cell culture */}
                <Route
                  path="/ReceiveCellCultureStock"
                  element={<StockReceived />}
                />
                <Route
                  path="/ReceiveMediaStock"
                  element={<MediaStockReceived />}
                />
                <Route
                  path="/ViewReceiveMediaStock/:id"
                  element={<ViewIReceiveMediaStock />}
                />
                <Route
                  path="/ViewCellCultureStock/:id"
                  element={<ViewCCStockDetail />}
                />
                <Route
                  path="/editCellSensitivityForm/:id"
                  element={<EditCellSensitivityForm />}
                />
                <Route
                  path="/viewCellSensitivityForm/:id"
                  element={<ViewCellSensitivityForm />}
                />
                {/* <Route path="/cellBankingForm" element={<CellLineReceiveListing />} /> */}
                {/* ....................Cell Banking................. */}
                <Route
                  path="/masterCellBank"
                  element={<CellLineMasterBandkListing />}
                />
                {/* ....................Cell Working................. */}
                <Route
                  path="/workingCellBank"
                  element={<CellLinesWorkingCellBankListing />}
                />
                {/* ....................Cell Storage................. */}
                <Route
                  path="/cellLineStorage"
                  element={<CellLinesStorageListing />}
                />
                {/* ....................Cell line Subculturing................. */}
                <Route
                  path="/CelllineSubculturing"
                  element={<CelllineSubculturingListing />}
                />
                <Route
                  path="/NewCelllineSubculturing"
                  element={<NewCelllineSubculturing />}
                />
                <Route
                  path="/EditCelllineSubculturing/:id"
                  element={<EditCelllineSubculturing />}
                />
                {/* <Route
								path='/ViewCelllineSubculturing/:id'
								element={<ViewCelllineSubculturing />}
							/> */}
                {/* ....................Cell line Subculturing................. */}
                <Route
                  path="/cellDocumentation"
                  element={<CellDocumentationRoot />}
                />
                {/* =============Inventory Routes==============================*/}
                <Route path="/Equipment" element={<Equipment />} />
                <Route path="/addEquipment" element={<AddEquipment />} />
                <Route path="/addItem" element={<AddItem />} />
                <Route path="/items" element={<InventoryItems />} />
                <Route path="/additems" element={<InventoryAddItem />} />
                <Route path="/items/:id" element={<EditInventoryItem />} />
                <Route path="/editEquipment/:id" element={<EquipmentEdit />} />
                {/* Procurement Routes */}
                <Route path="/procurements" element={<Procurement />} />
                <Route
                  path="/addProcurement"
                  element={<RequestProcurement />}
                />
                <Route
                  path="/POManagementSystem/:id"
                  element={<POManagementSystem />}
                />
                <Route
                  path="/viewProcurementDetail/:id"
                  element={<ViewProcurementDetail />}
                />
                <Route
                  path="/editProcurementDetail/:id"
                  element={<EditProcurementDetail />}
                />
                <Route
                  path="/POManangementSystem/PODetail/:poId"
                  element={<ViewPODetail />}
                />
                {/* <Route path='/PurchaseOrder' element={<Inventory />} /> */}
                <Route path="/ReceiveInvetory" element={<ReceiveInvetory />} />
                <Route path="/addReceiveInfo" element={<AddReceiveInfo />} />
                <Route path="/issuance" element={<Issuance />} />
                <Route path="/currentBalance" element={<CurrentBalance />} />
                <Route
                  path="/viewIssuanceDetail/:id"
                  element={<ViewIssuanceDetail />}
                />
                <Route path="/issueStock" element={<InventoryIssuance />} />
                <Route path="/StockReceive" element={<StockList />} />
                <Route
                  path="/viewReceivedDetail/:id"
                  element={<ViewStockReceivedDetail />}
                />
                <Route path="/Requisition" element={<Requisition />} />
                <Route path="/newRequisition" element={<NewRequisition />} />
                <Route
                  path="/viewDetail/:id"
                  element={<ViewInventoryDetail />}
                />
                <Route path="/PCRPurifiction" element={<PCRPurification />} />
                <Route
                  path="/RepeatfromSequencing"
                  element={<RepeatfromSequencing />}
                />
                {/* Sequencing */}
                <Route path="/PendingExtraction" element={<SeqReferred />} />
                <Route
                  path="/initializedSeqBatches"
                  element={<SeqInitializedBatches />}
                />
                <Route path="/UpdatedRnaBatch" element={<UpdatedRnaBatch />} />
                <Route path="/PendingRTPCR" element={<ReferredRtPcr />} />
                {/* <Route path='/ReferredRtPcr' element={<ReferredRtPcr />} /> */}
                <Route path="/CycleSequencing" element={<CycleSequencing />} />
                <Route
                  path="/PendingCycleSequencing"
                  element={<PendingCycleSequencing />}
                />
                <Route
                  path="/cycleSequencingBatches"
                  element={<CycleSequencingBatches />}
                />
                <Route
                  path="/viewcycleSequencing/:id"
                  element={<ViewCycleSequencingBatches />}
                />
                <Route
                  path="/initializedCycleSequecing"
                  element={<InitializedCycleSequecing />}
                />
                <Route
                  path="/PendingDtrPurification"
                  element={<PendingDtrPurification />}
                />
                <Route
                  path="/dtrPurificationBatches"
                  element={<DtrPurificationBatches />}
                />
                <Route
                  path="/sequencingReport"
                  element={<SequencingReport />}
                />
                <Route
                  path="/sequencingPendingList"
                  element={<SequencingPendingResult />}
                />
                <Route path="/itdPendingList" element={<ItdPendingResult />} />
                <Route
                  path="/l20BPositiveList"
                  element={<L20BPositiveResult />}
                />
                <Route
                  path="/culturePendingResults"
                  element={<CulturePendingResults />}
                />
                <Route
                  path="/labWeeklyProgressReport"
                  element={<LabWeeklyProgressReport />}
                />
                {/* <Route
								path='/environmentObservation'
								element={<EnvObservation />}
							/> */}
                <Route
                  path="/envDataManagement"
                  element={<ManageEnvObservation />}
                />
                <Route path="/viewenv/:id" element={<ViewEnv />} />
                <Route
                  path="/viewenvObservation/:id"
                  element={<ViewEnvObservation />}
                />
                <Route path="/dataRepository" element={<DataRepository />} />
                {/* reports */}
                <Route
                  path="esComplianceReport"
                  element={<EsSitesComplianceReport />}
                />
                <Route
                  path="esSamplingSchedule"
                  element={<EsSitesSamplingSchedule />}
                />
                <Route
                  path="provinceWiseSitesSummary"
                  element={<ProvinceWiseSitesMonthlySummary />}
                />
                <Route
                  path="esSitesWeeklySummary"
                  element={<EsSitesWeeklySummary />}
                />
                <Route
                  path="esSamplesReport"
                  element={<EsComplianceNewReport />}
                />
                <Route
                  path="/viewstoolinoculation/:id"
                  element={<ViewStoolInoculation />}
                />
                <Route path="/viewafp/:id" element={<ViewAFP />} />
                <Route path="/EditRNABatch" element={<EditRnaBatch />} />
                <Route path="*" element={<PageNotFount />} />
                {/*  */}
                <Route path="/RTPCRResult" element={<RTPCRResult />} />
                <Route path="/reports" element={<AnalyticalReport />} />
                <Route path="/editenvsample/:id" element={<EditEnvSample />} />
                <Route path="/tableCol" element={<ColumnInRow />} />
                <Route path="/sewagedatasheet" element={<SewageDatasheet />} />
                <Route path="/ItdTableSheet" element={<ItdTableSheet />} />
                <Route path="/InoculatedBatch" element={<ModalTable />} />
                <Route path="/EnvInoculatedBatch" element={<EnvModalTable />} />
                <Route path="/dayWiseObservations" element={<SpacimanList />} />
                {/* ================== Afp Documentation ================== */}
                <Route
                  path="/afpDocumentation"
                  element={<AfpDocumentation />}
                />
                <Route
                  path="/EnvdayWiseObservations"
                  element={<EnvSpacimanList />}
                />
                <Route path="/esIsolates" element={<ESIsolates />} />
                <Route path="/esIsolatesList" element={<IsolatesList />} />
                <Route path="/isolates" element={<ReferredIsolates />} />
                <Route
                  path="/combinationResults"
                  element={<ItdVdpvResultsConfig />}
                />
                <Route
                  path="/SequencingReferReport"
                  element={<ItdtoSequencingReferredSheet />}
                />
                <Route path="/ITDReport" element={<ITDReport />} />
                {/* ITD Report (Daily/weekly/monthly)  */}
                <Route
                  path="/itdSummaryReport"
                  element={<ITDdailyWeeklyMonthlyReport />}
                />
                {/* Stool Isolates */}
                <Route path="/afpIsolates" element={<StoolIsolates />} />
                <Route
                  path="/dailyRecordsReport"
                  element={<DailyRecordsReport />}
                />
                <Route
                  path="/dailyRecordsReportEnv"
                  element={<ESDailyRecordsReport />}
                />
                <Route
                  path="/stoolIsolatesList"
                  element={<StoolIsolatesList />}
                />
                <Route
                  path="/processingReagents/"
                  element={<ProcessingReagents />}
                />
                <Route
                  path="/AFPVirusIsolationSheet"
                  element={<AFPVirusIsolationSheet />}
                />
                <Route
                  path="/afpStorageManagement"
                  element={<AFPManageSampleStorage />}
                />
                <Route path="/afpStorageList" element={<DiscardAfpSamples />} />
                <Route path="/moveafpSamples" element={<MoveAfpSamples />} />
                <Route path="/manageStorage" element={<ManageStorage />} />
                <Route
                  path="/isolatesInventoryList"
                  element={<IsolateInventoryList />}
                />
                <Route
                  path="/esIsolatesInventoryList"
                  element={<EsIsolateInventoryList />}
                />
                <Route
                  path="/envStorageManagement"
                  element={<ESManageSampleStorage />}
                />
                <Route
                  path="/itdStorageManagement"
                  element={<ITDManageSampleStorage />}
                />
                <Route
                  path="/reInoculationHistory/:id"
                  element={<ReInoculationHistory />}
                />
                <Route
                  path="/discardEnvSamples"
                  element={<DiscardEsSamples />}
                />
                <Route
                  path="/discardItdSamples"
                  element={<DiscardItdSamples />}
                />
                <Route path="/moveEsSamples" element={<MoveEsSamples />} />
                <Route path="/moveItdSamples" element={<MoveItdSamples />} />
                <Route path="/afpErrorReport" element={<AFPErrorReport />} />
                <Route path="/envManageStorage" element={<EsManageStorage />} />
                <Route
                  path="/itdManageStorage"
                  element={<ItdManageStorage />}
                />
                <Route
                  path="/npevSlRateReport"
                  element={<NpevAndSlRateReport />}
                />
                <Route
                  path="/tatComplianceReport"
                  element={<TatComplianceReport />}
                />
                <Route
                  path="/weeklyQualityControlReport"
                  element={<WeeklyQCReport />}
                />
                <Route
                  path="/wpvMonitoringReport"
                  element={<WpvMonitoringReport />}
                />
                <Route
                  path="/workloadAndThroughputReport"
                  element={<WorkloadAndThroughputReport />}
                />
                <Route
                  path="/diagnosticAccuracyReport"
                  element={<DiagnosticAccuracyReport />}
                />
                <Route
                  path="/afpErrorReportList"
                  element={<AFPErrorReportList />}
                />
                <Route path="/envErrorReport" element={<EsErrorReport />} />
                <Route
                  path="/envErrorReportList"
                  element={<EsErrorReportList />}
                />
                <Route
                  path="/afpManageStorageCapacity"
                  element={<ManageStorageCapacity mode="afp" />}
                />
                <Route
                  path="/discardedSamples"
                  element={<DiscardedSamples />}
                />
                <Route
                  path="/envDiscardedSamples"
                  element={<EsDiscardedSamples />}
                />
                <Route
                  path="/itdDiscardedSamples"
                  element={<ItdDiscardedSamples />}
                />
                <Route
                  path="/envManageStorageCapacity"
                  element={<ManageStorageCapacity mode="env" />}
                />
                <Route
                  path="/itdManageStorageCapacity"
                  element={<ManageStorageCapacity mode="itd" />}
                />
                <Route
                  path="/stool&supernatantStorage"
                  element={<InventoryList />}
                />
                <Route
                  path="/controlsManagement"
                  element={<ControlsObservationManagement />}
                />
                <Route
                  path="/envControlsManagement"
                  element={<EScontrolsObservationManagement />}
                />
                <Route
                  path="/SequencingResults"
                  element={<SequencingResults />}
                />
                <Route
                  path="/SequencingResultBatches"
                  element={<SequencingResultBatches />}
                />
                <Route
                  path="/seqResultsVerification"
                  element={<SeqResultsVerification />}
                />
                <Route path="/finalBatchReport" element={<FinalBatches />} />
                <Route path="/pcrVerification" element={<PcrVerification />} />
                <Route
                  path="/workloadAndResultDashboard"
                  element={<WorkloadAndResultDashboard />}
                />
                <Route path="/itdDashboard" element={<ITDReportDashboard />} />
                <Route
                  path="/sequencingDashboard"
                  element={<SequencingReportDashboard />}
                />
                <Route
                  path="/procurementDashboard"
                  element={<ProcurementDashboard />}
                />
              </Route>
            </Route>

            <Route path="/" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
          </Routes>
        </Suspense>
      </div>
    </SnackbarProvider>
  );
}

export default App;
